import type { ShortcutHandlerContext } from '../../../../../../lib/types.js';
import { handleShortcutFileBrowserList } from '../../../../../lib/file-browser/handle-list.js';

/** GET /api/sessions/:sessionId/files/list */
export async function GET(ctx: ShortcutHandlerContext): Promise<void> {
  await handleShortcutFileBrowserList(ctx, ctx.params.sessionId);
}
